import logo from './logo/logo.png';
import logoFull from './logo/logo_full.png';

const config: ThemeConfig = {
  useInterfaceLanguageForButtons: false,
  hideInformationPopup: false,
  logo: {
    default: logo,
    full: logoFull,
    altText: 'Capturator - Languages online',
  },
};

export default config;
